(function () {
    "use strict";

    // ----------------------------
    // Config / Defaults
    // ----------------------------
    var DEFAULTS = {
        orientation: "landscape",
        zoom: { default: 2, min: 2, max: 80 },
        initialView: { lng: 5, lat: 50, zoom: 2 },
        usStatesAt: 5.0,
    };

    // Continents
    var CONTINENTS = [
        { key: "North America", name: "North America", lng: -100, lat: 48, handoffAt: 3.0 },
        { key: "South America", name: "South America", lng: -60, lat: -15, handoffAt: 4.0 },
        { key: "Europe", name: "Europe", lng: 15, lat: 48, handoffAt: 5.0 },
        { key: "Africa", name: "Africa", lng: 20, lat: 8, handoffAt: 3.0 },
        { key: "Asia", name: "Asia", lng: 90, lat: 35, handoffAt: 3.0 },
        { key: "Oceania", name: "Oceania", lng: 140, lat: -25, handoffAt: 3.0 },
    ];

    var US_STATES = [
        { name: "Alabama", abbr: "AL", lat: 32.806671, lng: -86.79113 },
        { name: "Alaska", abbr: "AK", lat: 61.370716, lng: -152.404419 },
        { name: "Arizona", abbr: "AZ", lat: 33.729759, lng: -111.431221 },
        { name: "Arkansas", abbr: "AR", lat: 34.969704, lng: -92.373123 },
        { name: "California", abbr: "CA", lat: 36.116203, lng: -119.681564 },
        { name: "Colorado", abbr: "CO", lat: 39.059811, lng: -105.311104 },
        { name: "Connecticut", abbr: "CT", lat: 41.597782, lng: -72.755371 },
        { name: "Delaware", abbr: "DE", lat: 39.318523, lng: -75.507141 },
        { name: "Florida", abbr: "FL", lat: 27.766279, lng: -81.686783 },
        { name: "Georgia", abbr: "GA", lat: 33.040619, lng: -83.643074 },
        { name: "Hawaii", abbr: "HI", lat: 21.094318, lng: -157.498337 },
        { name: "Idaho", abbr: "ID", lat: 44.240459, lng: -114.478828 },
        { name: "Illinois", abbr: "IL", lat: 40.349457, lng: -88.986137 },
        { name: "Indiana", abbr: "IN", lat: 39.849426, lng: -86.258278 },
        { name: "Iowa", abbr: "IA", lat: 42.011539, lng: -93.210526 },
        { name: "Kansas", abbr: "KS", lat: 38.5266, lng: -96.726486 },
        { name: "Kentucky", abbr: "KY", lat: 37.66814, lng: -84.670067 },
        { name: "Louisiana", abbr: "LA", lat: 31.169546, lng: -91.867805 },
        { name: "Maine", abbr: "ME", lat: 44.693947, lng: -69.381927 },
        { name: "Maryland", abbr: "MD", lat: 39.063946, lng: -76.802101 },
        { name: "Massachusetts", abbr: "MA", lat: 42.230171, lng: -71.530106 },
        { name: "Michigan", abbr: "MI", lat: 43.326618, lng: -84.536095 },
        { name: "Minnesota", abbr: "MN", lat: 45.694454, lng: -93.900192 },
        { name: "Mississippi", abbr: "MS", lat: 32.741646, lng: -89.678696 },
        { name: "Missouri", abbr: "MO", lat: 38.456085, lng: -92.288368 },
        { name: "Montana", abbr: "MT", lat: 46.921925, lng: -110.454353 },
        { name: "Nebraska", abbr: "NE", lat: 41.12537, lng: -98.268082 },
        { name: "Nevada", abbr: "NV", lat: 38.313515, lng: -117.055374 },
        { name: "New Hampshire", abbr: "NH", lat: 43.452492, lng: -71.563896 },
        { name: "New Jersey", abbr: "NJ", lat: 40.298904, lng: -74.521011 },
        { name: "New Mexico", abbr: "NM", lat: 34.840515, lng: -106.248482 },
        { name: "New York", abbr: "NY", lat: 42.165726, lng: -74.948051 },
        { name: "North Carolina", abbr: "NC", lat: 35.630066, lng: -79.806419 },
        { name: "North Dakota", abbr: "ND", lat: 47.528912, lng: -99.784012 },
        { name: "Ohio", abbr: "OH", lat: 40.388783, lng: -82.764915 },
        { name: "Oklahoma", abbr: "OK", lat: 35.565342, lng: -96.928917 },
        { name: "Oregon", abbr: "OR", lat: 44.572021, lng: -122.070938 },
        { name: "Pennsylvania", abbr: "PA", lat: 40.590752, lng: -77.209755 },
        { name: "Rhode Island", abbr: "RI", lat: 41.680893, lng: -71.51178 },
        { name: "South Carolina", abbr: "SC", lat: 33.856892, lng: -80.945007 },
        { name: "South Dakota", abbr: "SD", lat: 44.299782, lng: -99.438828 },
        { name: "Tennessee", abbr: "TN", lat: 35.747845, lng: -86.692345 },
        { name: "Texas", abbr: "TX", lat: 31.054487, lng: -97.563461 },
        { name: "Utah", abbr: "UT", lat: 40.150032, lng: -111.862434 },
        { name: "Vermont", abbr: "VT", lat: 44.045876, lng: -72.710686 },
        { name: "Virginia", abbr: "VA", lat: 37.769337, lng: -78.169968 },
        { name: "Washington", abbr: "WA", lat: 47.400902, lng: -121.490494 },
        { name: "West Virginia", abbr: "WV", lat: 38.491226, lng: -80.954453 },
        { name: "Wisconsin", abbr: "WI", lat: 44.268543, lng: -89.616508 },
        { name: "Wyoming", abbr: "WY", lat: 42.755966, lng: -107.30249 },
        { name: "District of Columbia", abbr: "DC", lat: 38.9072, lng: -77.0369 },
        ];

    var HANDOFF_OVERRIDES = new Map([["Russia", "Asia"]]);

    var AREA_TIERS = [
        { key: "huge", min: 5000000 },
        { key: "large", min: 1500000 },
        { key: "medium", min: 500000 },
        { key: "small", min: 150000 },
        { key: "tiny", min: 0 },
    ];

    // ----------------------------
    // Compat helpers
    // ----------------------------
    function hasAbortController() {
        return typeof window.AbortController === "function";
    }

    function createAbortControllerOrFallback() {
        if (hasAbortController()) return new AbortController();

        // Fallback: "signal" object
        return {
            signal: { aborted: false },
            abort: function () {
                this.signal.aborted = true;
            },
        };
    }

    // ----------------------------
    // Custom Element
    // ----------------------------
    class WorldMapElement extends HTMLElement {
        connectedCallback() {
            if (this._mounted) return;
            this._mounted = true;
            this._isReady = false;

            // Globals check
            if (!window.d3) {
                console.error("[world-map] d3 not found. Make sure vendor-d3-topojson.js is loaded before world-map.js");
                return;
            }
            if (!window.topojson) {
                console.error("[world-map] topojson not found. Make sure vendor-d3-topojson.js is loaded before world-map.js");
                return;
            }

            var dialogId = this.dataset.dialogId;
            if (!dialogId) {
                console.error("[world-map] dialogId not found. Make sure tp add dialogId");
                return;
            }

            // Scoped DOM
            this.triggerEl = this.querySelector("[data-map-world-trigger]");
            this.triggerCloseEl = this.querySelector("[data-map-world-trigger-close]");
            this.dialogElement = document.getElementById(dialogId);
            this.svgEl = this.querySelector("[data-map-world]");
            this.popoverEl = this.querySelector("[data-map-popover]");

            this.worldUrl = this.dataset.worldUrl;
            
            var locationId = this.dataset.locationsId;
            if (!locationId) {
                console.warn("[world-map] Missing [data-locations-id] on <world-map>:", this);
                return;
            }
            
            this.locations = safeJsonParse(window[locationId], []);
            this.initialView = pickInitialView(this, DEFAULTS.initialView);

            if (!this.svgEl) {
                console.warn("[world-map] Missing [data-map-world] inside <world-map>:", this);
                return;
            }
            if (!this.popoverEl) {
                console.warn("[world-map] Missing [data-map-popover] inside <world-map>:", this);
                return;
            }
            if (!this.worldUrl) {
                console.warn("[world-map] Missing data-world-url on <world-map>:", this);
                return;
            }

            this.abortController = createAbortControllerOrFallback();

            this.usStatesAt = Number(this.dataset.usStatesAt) || DEFAULTS.usStatesAt;

            this.init()
                .catch(function (err) {
                    console.error("[world-map] init failed:", err);
                });
        }

        disconnectedCallback() {
            if (this.abortController && typeof this.abortController.abort === "function") {
                this.abortController.abort();
            }

            if (this.resizeObserver && typeof this.resizeObserver.disconnect === "function") {
                this.resizeObserver.disconnect();
            }
            this.resizeObserver = null;

            if (this._onWindowResize) {
                window.removeEventListener("resize", this._onWindowResize);
                this._onWindowResize = null;
            }

            // cleanup d3 listeners
            if (this.ctx && typeof this.ctx.destroy === "function") {
                this.ctx.destroy();
            }

            if (this.triggerEl && this._onTriggerClick) {
                this.triggerEl.removeEventListener("click", this._onTriggerClick);
            }

            if (this.triggerCloseEl && this._onTriggerCloseClick) {
                this.triggerCloseEl.removeEventListener("click", this._onTriggerCloseClick);
            }

            this._mounted = false;
        }

        onTriggerClick(event) {
            event.preventDefault();
            event.stopPropagation();

            if (!this._isReady) return;

            this.toggleManualFullscreen();
        }

        onTriggerCloseClick() {
            if (!this._isReady) return;
            this.toggleManualFullscreen(false);
        }

        toggleManualFullscreen(forceState) {
            var self = this;

            var view =
                (self.ctx && self.ctx.getLastUserView && self.ctx.getLastUserView()) ||
                self._lastViewBeforeResize ||
                (self.ctx ? self.ctx.getView() : null);

            self._lastViewBeforeResize = view;

            var next = (typeof forceState === "boolean") ? forceState : !self._isManualFullScreen;
            self._isManualFullScreen = next;

            if (next) document.documentElement.classList.add("world-map-fullscreen");
            else document.documentElement.classList.remove("world-map-fullscreen");

            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    self.ctx.layout();

                    if (view) self.ctx.restoreView(view);

                    if (!next && self.dialogElement) {
                        self.dialogElement.removeAttribute("open");
                    }
                });
            });
        }

        init() {
            var self = this;

            if (self.triggerEl) {
                self._onTriggerClick = self.onTriggerClick.bind(self);
                self.triggerEl.addEventListener("click", self._onTriggerClick);
            }

            if (self.triggerCloseEl) {
                self._onTriggerCloseClick = self.onTriggerCloseClick.bind(self);
                self.triggerCloseEl.addEventListener("click", self._onTriggerCloseClick);
            }

            self.ctx = createMapContext({
                host: self,
                svgEl: self.svgEl,
                dialogEl: self.dialogElement,
                popoverEl: self.popoverEl,
                zoom: DEFAULTS.zoom,
                locations: self.locations,
            });

            // Load world topojson/geojson
            return loadWorld(self.worldUrl, self.abortController.signal)
                .then(function (world) {
                    if (self.abortController && self.abortController.signal && self.abortController.signal.aborted) return;

                    self.world = world;
                    self.ctx.setWorld(world);

                    // Countries dataset
                    var countries = loadCountries();
                    self.countries = countries;
                    self.ctx.setCountries(countries);

                    // Initial render
                    self.ctx.setInitialView(self.initialView);
                    self.ctx.render();

                    // Wait for svg to have its real size and is loaded
                    self.waitForStableSize().then(function () {
                        console.log('waitForStableSize then called')
                        // Force 1x layout + view restore so that everything is working
                        var v = self.ctx.getView();
                        self.ctx.layout();
                        if (v) self.ctx.restoreView(v);

                        self._isReady = true;
                    }).catch(function(error) {
                        console.warn('waitForStableSize err', error)
                    });

                    self._onWindowResize = function () {
                        var prevView = self.ctx.getView();

                        self.ctx.layout();

                        var previous = self.initialView ? self.initialView.orientation : null;
                        var next = pickInitialView(self, DEFAULTS.initialView);

                        if (previous && next.orientation !== previous) {
                            self.initialView = next;
                            self.ctx.resetToInitialView(next);
                        } else {
                            self.initialView = next;
                            requestAnimationFrame(function () {
                            self.ctx.restoreView(prevView);
                            });
                        }
                    };

                    window.addEventListener("resize", self._onWindowResize);
                });
        }

        waitForStableSize() {
            var self = this;

            return new Promise(function (resolve) {
                var tries = 0;
                var last = null;
                var stableCount = 0;

                function readSize() {
                    var hostRect = self.getBoundingClientRect();
                    var svgRect = self.svgEl ? self.svgEl.getBoundingClientRect() : { width: 0, height: 0 };

                    return {
                        hw: Math.round(hostRect.width),
                        hh: Math.round(hostRect.height),
                        sw: Math.round(svgRect.width),
                        sh: Math.round(svgRect.height),
                    };
                }

                function tick() {
                    tries++;

                    var s = readSize();

                    var ok = s.hw > 10 && s.hh > 10 && s.sw > 10 && s.sh > 10;

                    if (ok && last && s.hw === last.hw && s.hh === last.hh && s.sw === last.sw && s.sh === last.sh) {
                        stableCount++;
                    } else {
                        stableCount = 0;
                    }

                    last = s;

                    // stable for 2 frames
                    if (ok && stableCount >= 2) return resolve();

                    // safety: after ~120 frames (~2s @60fps)
                    if (tries > 120) return resolve();

                    requestAnimationFrame(tick);
                }

                requestAnimationFrame(tick);
            });
            }
    }

    if (!customElements.get("world-map")) {
        customElements.define("world-map", WorldMapElement);
    }

    function createMapContext(opts) {
        var host = opts.host;
        var dialogEl = opts.dialogEl;
        var svgEl = opts.svgEl;
        var popoverEl = opts.popoverEl;
        var colors = opts.colors;
        var zoom = opts.zoom;
        var locations = opts.locations;
        var usStatesAt = Number(opts.usStatesAt) || DEFAULTS.usStatesAt;

        var states = US_STATES;

        var svgSel = d3.select(svgEl);

        // Layers: map -> labels -> markers
        var mapLayer = svgSel.append("g").attr("class", "map-layer");
        var labelLayer = svgSel.append("g").attr("class", "label-layer");
        var markerLayer = svgSel.append("g").attr("class", "marker-layer");

        var projection = d3.geoNaturalEarth1();
        var path = d3.geoPath(projection);

        // State
        var world = null;
        var countries = null;
        var initialView = DEFAULTS.initialView;

        // continent handoff map
        var HANDOFF_BY_CONTINENT = new Map(CONTINENTS.map(function (c) { return [c.key, c.handoffAt]; }));
        function handoffAtFor(continentKey) {
            var v = HANDOFF_BY_CONTINENT.get(continentKey);
            return v == null ? 3.0 : v;
        }

        // sizing
        function size() {
            var r = host.getBoundingClientRect();
            return { w: Math.max(1, r.width), h: Math.max(1, r.height) };
        }

        function setViewBoxToHost() {
            var s = size();
            svgSel.attr("viewBox", "0 0 " + s.w + " " + s.h);
            return s;
        }

        // controllers
        var popover = createPopoverController({ svgEl: svgEl, dialogEl: dialogEl, popoverEl: popoverEl, projection: projection });

        var lastUserView = null;

        var zoomController = createZoomController({
            svgEl: svgEl,
            svgSel: svgSel,
            mapLayer: mapLayer,
            labelLayer: labelLayer,
            markerLayer: markerLayer,
            projection: projection,
            zoom: zoom,
            handoffAtFor: handoffAtFor,
            popover: popover,
            usStatesAt: usStatesAt,
            onViewChanged: function (v) {
                lastUserView = v;
            },
        });

        // close popover when clicking background
        svgSel.on("click.worldmap", function () {
            popover.clear();
        });

        function setWorld(worldGeoJson) {
            world = worldGeoJson;
        }

        function setCountries(countriesData) {
            countries = countriesData;
        }

        function setInitialView(view) {
            initialView = view || DEFAULTS.initialView;
        }

        function render() {
            if (!world) throw new Error("[world-map] render(): world data missing");

            renderWorld({ projection: projection, path: path, mapLayer: mapLayer, colors: colors, setViewBoxToHost: setViewBoxToHost }, world);

            renderMarkers({
                markerLayer: markerLayer,
                projection: projection,
                worldSvgElement: svgEl,
                openForMarker: popover.openForMarker,
                colors: colors,
                locations: locations,
            });

            renderContinentLabels({ labelLayer: labelLayer, projection: projection });

            if (Array.isArray(countries) && countries.length) {
                renderCountryLabels({ labelLayer: labelLayer, projection: projection, countries: countries });
                renderStateLabels({ labelLayer: labelLayer, projection: projection, states: states });
            } else {
                labelLayer.selectAll("g.country-labels").remove();
            }

            if (initialView) zoomController.zoomToLatLng(initialView.lng, initialView.lat, initialView.zoom);

            zoomController.sync();
        }

        function layout() {
            if (!world) return;

            renderWorld({ projection: projection, path: path, mapLayer: mapLayer, colors: colors, setViewBoxToHost: setViewBoxToHost }, world);

            renderMarkers({
                markerLayer: markerLayer,
                projection: projection,
                worldSvgElement: svgEl,
                openForMarker: popover.openForMarker,
                colors: colors,
                locations: locations,
            });

            renderContinentLabels({ labelLayer: labelLayer, projection: projection });

            if (Array.isArray(countries) && countries.length) {
                renderCountryLabels({ labelLayer: labelLayer, projection: projection, countries: countries });
                renderStateLabels({ labelLayer: labelLayer, projection: projection, states: states });
            }

            zoomController.sync();
        }

        function resetToInitialView(view) {
            setInitialView(view);
            if (view) {
                zoomController.zoomToLatLng(view.lng, view.lat, view.zoom);
            }
            zoomController.sync();
        }

        function getView() {
            return zoomController.getView();
        }

        function restoreView(view) {
            zoomController.setView(view);
            zoomController.sync();
        }

        function getLastUserView() {
            return lastUserView;
        }

        function destroy() {
            svgSel.on("click.worldmap", null);
            svgSel.on(".zoom", null);

            popover.clear();
        }

        return {
            setWorld: setWorld,
            setCountries: setCountries,
            setInitialView: setInitialView,
            resetToInitialView: resetToInitialView,
            render: render,
            layout: layout,

            getView: getView,
            restoreView: restoreView,
            getLastUserView: getLastUserView,

            destroy: destroy,
        };
    }

    // ----------------------------
    // Renderers
    // ----------------------------
    function renderWorld(ctx, worldGeoJson) {
        var projection = ctx.projection;
        var path = ctx.path;
        var mapLayer = ctx.mapLayer;
        var colors = ctx.colors;
        var setViewBoxToHost = ctx.setViewBoxToHost;

        var s = setViewBoxToHost();
        projection.fitSize([s.w, s.h], worldGeoJson);

        mapLayer
            .selectAll("path.land")
            .data(worldGeoJson.features)
            .join("path")
            .attr("class", "land")
            .attr("d", path)
            .attr("vector-effect", "non-scaling-stroke");
    }

    function renderContinentLabels(ctx) {
        var labelLayer = ctx.labelLayer;
        var projection = ctx.projection;

        var layer = labelLayer
            .selectAll("g.continent-labels")
            .data([null])
            .join("g")
            .attr("class", "continent-labels");

        var labels = layer
            .selectAll("g.continent-label")
            .data(CONTINENTS, function (d) { return d.key; })
            .join(function (enter) {
                var g = enter.append("g").attr("class", "continent-label");

                g.append("g")
                    .attr("class", "label-scale")
                    .append("text")
                    .attr("text-anchor", "middle")
                    .attr("dy", "0.35em");

                return g;
            });

        labels.attr("transform", function (d) {
            var p = projection([d.lng, d.lat]);
            if (!p) return "translate(-9999,-9999)";
            return "translate(" + p[0] + "," + p[1] + ")";
        });

        labels.select("g.label-scale > text").text(function (d) { return d.name; });

        return layer;
    }

    function renderCountryLabels(ctx) {
        var labelLayer = ctx.labelLayer;
        var projection = ctx.projection;
        var countries = ctx.countries;

        var layer = labelLayer
            .selectAll("g.country-labels")
            .data([null])
            .join("g")
            .attr("class", "country-labels");

        var labels = layer
            .selectAll("g.country-label")
            .data(countries, function (d) { return d.name; })
            .join(function (enter) {
                var g = enter.append("g").attr("class", function (d) { return "country-label tier-" + d.sizeTier; });

                g.append("g")
                    .attr("class", "label-scale")
                    .append("text")
                    .attr("text-anchor", "middle")
                    .attr("dy", "0.35em");

                return g;
            });

        labels.attr("transform", function (d) {
            var p = projection([d.lng, d.lat]);
            if (!p) return "translate(-9999,-9999)";
            return "translate(" + p[0] + "," + p[1] + ")";
        });

        labels.select("g.label-scale > text").text(function (d) { return d.name; });

        return layer;
    }

    function renderStateLabels(ctx) {
        var labelLayer = ctx.labelLayer;
        var projection = ctx.projection;
        var states = ctx.states;

        var layer = labelLayer
            .selectAll("g.state-labels")
            .data([null])
            .join("g")
            .attr("class", "state-labels");

        var labels = layer
            .selectAll("g.state-label")
            .data(states, function (d) { return d.name; })
            .join(function (enter) {
            var g = enter.append("g").attr("class", "country-label state-label tier-large");

            g.append("g")
                .attr("class", "label-scale")
                .append("text")
                .attr("text-anchor", "middle")
                .attr("dy", "0.35em");

            return g;
            });

        labels.attr("transform", function (d) {
            var p = projection([d.lng, d.lat]);
            if (!p) return "translate(-9999,-9999)";
            return "translate(" + p[0] + "," + p[1] + ")";
        });

        labels.select("g.label-scale > text").text(function (d) { return d.name; });

        return layer;
    }

    function renderMarkers(ctx) {
        var markerLayer = ctx.markerLayer;
        var projection = ctx.projection;
        var openForMarker = ctx.openForMarker;
        var locations = ctx.locations;

        var data = normalizeLocations(locations);

        var markerG = markerLayer
            .selectAll("g.markers")
            .data([null])
            .join("g")
            .attr("class", "markers");

        var markers = markerG
            .selectAll("g.marker")
            .data(data, function (d) { return d.id; })
            .join(function (enter) {
                var m = enter.append("g").attr("class", "marker");

                m.append("circle")
                    .attr("class", "marker-pulse")
                    .attr("r", 7);

                m.append("circle")
                    .attr("class", "marker-hit")
                    .attr("r", 13)
                    .attr("fill", "transparent")
                    .attr("stroke", "transparent");

                m.append("circle")
                    .attr("class", "marker-dot")
                    .attr("r", 7);

                return m;
            });

        markers.classed("marker--highlighted", function (d) { return !!d.highlighted; })
        markers.classed("marker--recent", function (d) { return !!d.recent; })

        markers.attr("transform", function (d) {
            var p = projection([d.lng, d.lat]);
            if (!p) return "translate(-9999,-9999)";
            return "translate(" + p[0] + ", " + p[1] + ")";
        });

        markers.on("click.worldmap", function (event, d) {
            event.stopPropagation();

            openForMarker({ lng: d.lng, lat: d.lat, name: d.name, items: d.items });
        });

        return { markersSelection: markers };
    }

    // ----------------------------
    // Controllers
    // ----------------------------
    function createPopoverController(opts) {
        var svgEl = opts.svgEl;
        var dialogEl = opts.dialogEl;
        var projection = opts.projection;

        var dialogContentEl = dialogEl.querySelector(".gb-dialog-body");
        if (!dialogContentEl) {
            console.error("[world-map] .gb-dialog-body not found in dialog element");
        }

        var openMarker = null; // { lng, lat, html }

        function isDialogOpen() {
            return dialogEl && dialogEl.hasAttribute("open");
        }

        function close() {
            dialogEl.removeAttribute("open");
            openMarker = null;
        }

        function openForMarker(marker) {
            openMarker = marker;

            dialogEl.setAttribute("open", "");
            dialogEl.setAttribute("dialog-title", marker.name);           
            
            if (dialogContentEl) {
                if (Array.isArray(marker.items)) {
                    dialogContentEl.innerHTML = buildDialogBodyHtml(marker.items);
                } else {
                    dialogContentEl.innerHTML = '';
                }

                if (dialogEl.resetScrollTop) {
                    dialogEl.resetScrollTop();
                }
            }
            
            updatePosition();
        }

        function updatePosition() {
            if (!openMarker) return;
            if (!isDialogOpen()) return;
        }

        function clear() {
            close();
        }

        return {
            openForMarker: openForMarker,
            close: close,
            clear: clear,
            updatePosition: updatePosition,
            getOpenMarker: function () { return openMarker; },
        };
    }

    function createZoomController(opts) {
        var svgEl = opts.svgEl;
        var svgSel = opts.svgSel;
        var mapLayer = opts.mapLayer;
        var labelLayer = opts.labelLayer;
        var markerLayer = opts.markerLayer;
        var projection = opts.projection;
        var zoom = opts.zoom;
        var handoffAtFor = opts.handoffAtFor;
        var popover = opts.popover;
        var onViewChanged = opts.onViewChanged;
        var usStatesAt = Number(opts.usStatesAt) || DEFAULTS.usStatesAt;

        function applyTransform(t) {
            svgSel.attr("data-zoom", zoomBucket(t.k));

            mapLayer.attr("transform", t);
            labelLayer.attr("transform", t);
            markerLayer.attr("transform", t);

            labelLayer.selectAll("g.label-scale").attr("transform", "scale(" + (1 / t.k) + ")");
        }

        function applyVisibility(t) {
            var showStates = t.k >= usStatesAt;

            // continent labels
            labelLayer
                .selectAll("g.continent-label")
                .classed("visible", function (d) { return t.k < handoffAtFor(d.key); });

            // country labels (US)
            labelLayer
                .selectAll("g.country-label")
                .classed("visible", function (d) {
                    var shouldShow = t.k >= handoffAtFor(d.handoffKey);
                    if (d.name === "United States") {
                        return shouldShow && !showStates;
                    }
                    return shouldShow;
                });

            // state labels (alleen US)
            labelLayer
                .selectAll("g.state-label")
                .classed("visible", function () { return showStates; });
        }

        function applyStyles(t) {
            mapLayer.selectAll("path.land").attr("stroke-width", strokeWidthForZoom(t.k, zoom.min, zoom.max));

            markerLayer.selectAll("g.marker").attr("transform", function (d) {
                var p = projection([d.lng, d.lat]);
                if (!p) return "translate(-9999,-9999)";
                return "translate(" + p[0] + ", " + p[1] + ") scale(" + (1 / t.k) + ")";
            });

            var hitR = t.k < 5 ? 13 : t.k < 12 ? 16 : 15;
            markerLayer.selectAll("circle.marker-hit").attr("r", hitR);
        }

        function applyAll(t) {
            applyTransform(t);
            applyVisibility(t);
            applyStyles(t);
            if (popover && typeof popover.updatePosition === "function") {
                popover.updatePosition();
            }
        }

        function notifyView() {
            if (!onViewChanged) return;
            var v = getView();
            if (v) onViewChanged(v);
        }

        var zoomBehavior = d3
            .zoom()
            .scaleExtent([zoom.min, zoom.max])
            .on("zoom", function (event) {
                applyAll(event.transform);
            })
            .on("end", function () {
                notifyView();
            });

        svgSel.call(zoomBehavior);

        function zoomToLatLng(lng, lat, scale) {
            var rect = svgEl.getBoundingClientRect();
            var width = rect.width;
            var height = rect.height;

            var p = projection([lng, lat]);
            if (!p) return;
            var x = p[0];
            var y = p[1];

            svgSel.call(
                zoomBehavior.transform,
                d3.zoomIdentity.translate(width / 2, height / 2).scale(scale).translate(-x, -y)
            );
        }

        function zoomToCenter(scale) {
            var rect = svgEl.getBoundingClientRect();
            var width = rect.width;
            var height = rect.height;

            svgSel.call(
                zoomBehavior.transform,
                d3.zoomIdentity.translate(width / 2, height / 2).scale(scale).translate(-width / 2, -height / 2)
            );
        }

        function sync() {
            applyAll(d3.zoomTransform(svgEl));
        }

        function getView() {
            var rect = svgEl.getBoundingClientRect();
            var cx = rect.width / 2;
            var cy = rect.height / 2;

            var t = d3.zoomTransform(svgEl);

            // screen -> world (svg coords)
            var wx = t.invertX(cx);
            var wy = t.invertY(cy);

            // world -> lng/lat
            var lngLat = projection.invert([wx, wy]); // [lng, lat] or null
            if (!lngLat) return null;

            return { lng: lngLat[0], lat: lngLat[1], k: t.k };
        }

        function setView(view) {
            if (!view) return;
            zoomToLatLng(view.lng, view.lat, view.k);
        }

        zoomToCenter(zoom.default);

        return {
            zoomBehavior: zoomBehavior,
            zoomToLatLng: zoomToLatLng,
            zoomToCenter: zoomToCenter,
            sync: sync,
            getView: getView,
            setView: setView,
        };
    }

    // ----------------------------
    // Data helpers
    // ----------------------------
    function buildDialogBodyHtml(items) {
        var list = Array.isArray(items) ? items : [];
        if (!list.length) {
            return '<div class="dialog-body__empty">No content configured for this location.</div>';
        }

        var out = '';
        var inVideosWrapper = false;

        function openVideos() {
            if (!inVideosWrapper) {
                inVideosWrapper = true;
                out += '<gb-carousel class="dialog-body__videos">';
            }
        }
        function closeVideos() {
            if (inVideosWrapper) {
                inVideosWrapper = false;
                out += '</gb-carousel>';
            }
        }

        for (var i = 0; i < list.length; i++) {
            var it = list[i] || {};
            var t = String(it.type || '');

            var isVideo = t === 'video';

            if (isVideo) openVideos();
            else closeVideos();

            if (t === 'text') {
                if (it.html) {
                    out += '<div class="dialog-body__text">' + it.html + '</div>';
                }
            } else if (t === 'image') {
                if (it.src) {
                    var alt = it.alt || '';
                    var w = it.width || '';
                    var h = it.height || '';
                    out += (
                        '<div class="dialog-body__image">' +
                            '<img src="' + escapeAttr(it.src) + '" alt="' + escapeAttr(alt) + '" loading="lazy"' +
                            (w ? ' width="' + escapeAttr(String(w)) + '"' : '') +
                            (h ? ' height="' + escapeAttr(String(h)) + '"' : '') +
                            ' />' +
                        '</div>'
                    );
                }
            } else if (t === 'button') {
                if (it.url) {
                    var label = (typeof it.label === 'string' && it.label.trim())
                        ? it.label.trim()
                        : 'Learn more';

                    var isExternal = it.external === true;

                    var extra = isExternal
                        ? ' target="_blank" rel="noopener noreferrer"'
                        : '';

                    out += (
                        '<div class="dialog-body__cta">' +
                            '<a class="button button--primary"' +
                                ' href="' + escapeAttr(it.url) + '"' +
                                extra +
                            '>' +
                                escapeHtml(label) +
                            '</a>' +
                        '</div>'
                    );
                }
            } else if (t === 'video') {
                if (it.html) {
                    out += '<div class="dialog-body__video">' + it.html + '</div>';
                }
            } else if (t === 'empty') {
                out += '<div class="dialog-body__empty">' + escapeHtml(it.text || 'No content configured for this location.') + '</div>';
            }
        }

        closeVideos();
        return out;
    }

    // Minimal escapers (voor attrs / plain text)
    function escapeHtml(s) {
        return String(s)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }
    function escapeAttr(s) {
        // voor attributen: zelfde als escapeHtml is prima
        return escapeHtml(s);
    }

    function pickInitialView(el, fallback) {
        var isPortrait = false;
        try {
            isPortrait = window.matchMedia && window.matchMedia("(orientation: portrait)").matches;
        } catch (e) {}

        var portraitStr = el.dataset.initialViewPortrait;
        var landscapeStr = el.dataset.initialViewLandscape;

        if (isPortrait && portraitStr) {
            var vP = safeJsonParse(portraitStr, null);
            if (vP) {
            vP.orientation = "portrait";
            return vP;
            }
        }

        if (!isPortrait && landscapeStr) {
            var vL = safeJsonParse(landscapeStr, null);
            if (vL) {
            vL.orientation = "landscape";
            return vL;
            }
        }

        var v = fallback || {};
        v = { lng: v.lng, lat: v.lat, zoom: v.zoom };
        v.orientation = isPortrait ? "portrait" : "landscape";
        return v;
    }

    function parseISODateToMs(s) {
        if (!s || typeof s !== "string") return NaN;
        var t = Date.parse(s);
        return Number.isFinite(t) ? t : NaN;
    }

    function normalizeLocations(locations) {
        var list = Array.isArray(locations) ? locations : [];
        var normalized = list.map(function (l) {
            var id = l && (l.id != null ? l.id : l.name);
            if (id == null) id = "";

            var dateStr = (l && l.date) ? String(l.date) : "";
            var dateMs = parseISODateToMs(dateStr);

            return {
                id: id,
                name: (l && l.name) ? l.name : "",
                highlighted: !!(l && l.highlighted),
                lat: Number(l ? l.lat : NaN),
                lng: Number(l ? l.lng : NaN),
                items: (l && Array.isArray(l.items)) ? l.items : null,
                // html: (l && l.html) ? l.html : "",
                date: dateStr,
                _dateMs: dateMs,     // internal for sorting
                recent: false,       // set later
            };
        });

        var now = Date.now();
        var ONE_DAY_MS = 24 * 60 * 60 * 1000;

        var bestIndex = -1;
        var bestDelta = Infinity;

        for (var i = 0; i < normalized.length; i++) {
            var ms = normalized[i]._dateMs;
            if (!Number.isFinite(ms)) continue;

            var isFuture = ms >= now;
            var isRecentPast = ms < now && (now - ms) <= ONE_DAY_MS;

            if (!isFuture && !isRecentPast) continue;

            var delta = Math.abs(ms - now);

            // smallest distance till "now" wins
            // tie-break: if the same, take future
            if (delta < bestDelta || (delta === bestDelta && isFuture)) {
            bestDelta = delta;
            bestIndex = i;
            }
        }

        if (bestIndex !== -1) normalized[bestIndex].recent = true;

        for (var j = 0; j < normalized.length; j++) delete normalized[j]._dateMs;

        return normalized;
    }

    // ----------------------------
    // Zoom style utils
    // ----------------------------
    function clamp01(x) {
        return Math.max(0, Math.min(1, x));
    }

    function smoothstep01(x) {
        var t = clamp01(x);
        return t * t * (3 - 2 * t);
    }

    function logEase(k, min, max) {
        var t = (Math.log(k) - Math.log(min)) / (Math.log(max) - Math.log(min));
        return smoothstep01(t);
    }

    function strokeWidthForZoom(k, zoomMin, zoomMax) {
        var eased = logEase(k, zoomMin, zoomMax);
        var maxW = 1.8;
        var minW = 1.2;
        return maxW + (minW - maxW) * eased;
    }

    function zoomBucket(k) {
        if (k < 3) return "z2";
        if (k < 5) return "z3";
        if (k < 8) return "z5";
        if (k < 12) return "z8";
        if (k < 15) return "z10";
        return "z12";
    }

    // ----------------------------
    // Load helpers (fetch + XHR fallback)
    // ----------------------------
    function safeJsonParse(str, fallback) {
        if (str && typeof str === 'object') {
            return str;
        }
        
        if (typeof str !== 'string') {
            return fallback;
        }
        
        try {
            return str ? JSON.parse(str) : fallback;
        } catch (e) {
            console.log('safeJsonParse error:', e);
            return fallback;
        }
    }

    function loadJson(url, signal) {
        if (typeof window.fetch === "function") {
            return fetch(url, { signal: signal })
                .then(function (res) {
                    if (!res.ok) throw new Error("Failed to load " + url + ": " + res.status);
                    return res.json();
                });
        }

        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState !== 4) return;

                if (signal && signal.aborted) return;

                if (xhr.status >= 200 && xhr.status < 300) {
                    try {
                        resolve(JSON.parse(xhr.responseText));
                    } catch (e) {
                        reject(e);
                    }
                } else {
                    reject(new Error("Failed to load " + url + ": " + xhr.status));
                }
            };
            xhr.send(null);
        });
    }

    function loadWorld(url, signal) {
        return loadJson(url, signal).then(function (data) {
            if (signal && signal.aborted) return null;

            // topojson -> geojson
            if (data && data.objects) {
                var keys = Object.keys(data.objects);
                var objectName = keys.length ? keys[0] : null;
                if (objectName) {
                    return topojson.feature(data, data.objects[objectName]);
                }
            }
            return data;
        });
    }

    // ----------------------------
    // Countries
    // ----------------------------
    function loadCountries() {
        return [{name:"Afghanistan",lat:33,lng:65,continentKey:"Asia",handoffKey:"Asia",sizeTier:"medium"},{name:"Angola",lat:-12.5,lng:18.5,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Albania",lat:41,lng:20,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Andorra",lat:42.5,lng:1.5,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"United Arab Emirates",lat:24,lng:54,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Argentina",lat:-34,lng:-64,continentKey:"South America",handoffKey:"South America",sizeTier:"large"},{name:"Armenia",lat:40,lng:45,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Antigua and Barbuda",lat:17.05,lng:-61.8,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Australia",lat:-27,lng:133,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"huge"},{name:"Austria",lat:47.33333333,lng:13.33333333,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Azerbaijan",lat:40.5,lng:47.5,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Burundi",lat:-3.5,lng:30,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Belgium",lat:50.83333333,lng:4,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Benin",lat:9.5,lng:2.25,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Burkina Faso",lat:13,lng:-2,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"Bangladesh",lat:24,lng:90,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Bulgaria",lat:43,lng:25,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Bahrain",lat:26,lng:50.55,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Bahamas",lat:24.25,lng:-76,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Bosnia and Herzegovina",lat:44,lng:18,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Belarus",lat:53,lng:28,continentKey:"Europe",handoffKey:"Europe",sizeTier:"small"},{name:"Belize",lat:17.25,lng:-88.75,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Bolivia",lat:-17,lng:-65,continentKey:"South America",handoffKey:"South America",sizeTier:"medium"},{name:"Brazil",lat:-10,lng:-55,continentKey:"South America",handoffKey:"South America",sizeTier:"huge"},{name:"Barbados",lat:13.16666666,lng:-59.53333333,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Brunei",lat:4.5,lng:114.66666666,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Bhutan",lat:27.5,lng:90.5,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Botswana",lat:-22,lng:24,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Central African Republic",lat:7,lng:21,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Canada",lat:60,lng:-95,continentKey:"North America",handoffKey:"North America",sizeTier:"huge"},{name:"Switzerland",lat:47,lng:8,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Chile",lat:-30,lng:-71,continentKey:"South America",handoffKey:"South America",sizeTier:"medium"},{name:"China",lat:35,lng:105,continentKey:"Asia",handoffKey:"Asia",sizeTier:"huge"},{name:"Ivory Coast",lat:8,lng:-5,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"Cameroon",lat:6,lng:12,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"DR Congo",lat:0,lng:25,continentKey:"Africa",handoffKey:"Africa",sizeTier:"large"},{name:"Congo",lat:-1,lng:15,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"Colombia",lat:4,lng:-72,continentKey:"South America",handoffKey:"South America",sizeTier:"medium"},{name:"Comoros",lat:-12.16666666,lng:44.25,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Cape Verde",lat:16,lng:-24,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Costa Rica",lat:10,lng:-84,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Cuba",lat:21.5,lng:-80,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Cyprus",lat:35,lng:33,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Czechia",lat:49.75,lng:15.5,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Germany",lat:51,lng:9,continentKey:"Europe",handoffKey:"Europe",sizeTier:"small"},{name:"Djibouti",lat:11.5,lng:43,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Dominica",lat:15.41666666,lng:-61.33333333,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Denmark",lat:56,lng:10,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Dominican Republic",lat:19,lng:-70.66666666,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Algeria",lat:28,lng:3,continentKey:"Africa",handoffKey:"Africa",sizeTier:"large"},{name:"Ecuador",lat:-2,lng:-77.5,continentKey:"South America",handoffKey:"South America",sizeTier:"small"},{name:"Egypt",lat:27,lng:30,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Eritrea",lat:15,lng:39,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Spain",lat:40,lng:-4,continentKey:"Europe",handoffKey:"Europe",sizeTier:"medium"},{name:"Estonia",lat:59,lng:26,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Ethiopia",lat:8,lng:38,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Finland",lat:64,lng:26,continentKey:"Europe",handoffKey:"Europe",sizeTier:"small"},{name:"Fiji",lat:-18,lng:175,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"France",lat:46,lng:2,continentKey:"Europe",handoffKey:"Europe",sizeTier:"medium"},{name:"Micronesia",lat:6.91666666,lng:158.25,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"Gabon",lat:-1,lng:11.75,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"United Kingdom",lat:54,lng:-2,continentKey:"Europe",handoffKey:"Europe",sizeTier:"small"},{name:"Georgia",lat:42,lng:43.5,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Ghana",lat:8,lng:-2,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"Guinea",lat:11,lng:-10,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"Gambia",lat:13.46666666,lng:-16.56666666,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Guinea-Bissau",lat:12,lng:-15,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Equatorial Guinea",lat:2,lng:10,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Greece",lat:39,lng:22,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Grenada",lat:12.11666666,lng:-61.66666666,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Guatemala",lat:15.5,lng:-90.25,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Guyana",lat:5,lng:-59,continentKey:"South America",handoffKey:"South America",sizeTier:"small"},{name:"Honduras",lat:15,lng:-86.5,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Croatia",lat:45.16666666,lng:15.5,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Haiti",lat:19,lng:-72.41666666,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Hungary",lat:47,lng:20,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Indonesia",lat:-5,lng:120,continentKey:"Asia",handoffKey:"Asia",sizeTier:"large"},{name:"India",lat:20,lng:77,continentKey:"Asia",handoffKey:"Asia",sizeTier:"large"},{name:"Ireland",lat:53,lng:-8,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Iran",lat:32,lng:53,continentKey:"Asia",handoffKey:"Asia",sizeTier:"large"},{name:"Iraq",lat:33,lng:44,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Iceland",lat:65,lng:-18,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Israel",lat:31.47,lng:35.13,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Italy",lat:42.83333333,lng:12.83333333,continentKey:"Europe",handoffKey:"Europe",sizeTier:"small"},{name:"Jamaica",lat:18.25,lng:-77.5,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Jordan",lat:31,lng:36,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Japan",lat:36,lng:138,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Kazakhstan",lat:48,lng:68,continentKey:"Asia",handoffKey:"Asia",sizeTier:"large"},{name:"Kenya",lat:1,lng:38,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Kyrgyzstan",lat:41,lng:75,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Cambodia",lat:13,lng:105,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Kiribati",lat:1.41666666,lng:173,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"Saint Kitts and Nevis",lat:17.33333333,lng:-62.75,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"South Korea",lat:37,lng:127.5,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Kuwait",lat:29.5,lng:45.75,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Laos",lat:18,lng:105,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Lebanon",lat:33.83333333,lng:35.83333333,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Liberia",lat:6.5,lng:-9.5,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Libya",lat:25,lng:17,continentKey:"Africa",handoffKey:"Africa",sizeTier:"large"},{name:"Saint Lucia",lat:13.88333333,lng:-60.96666666,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Liechtenstein",lat:47.26666666,lng:9.53333333,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Sri Lanka",lat:7,lng:81,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Lesotho",lat:-29.5,lng:28.5,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Lithuania",lat:56,lng:24,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Luxembourg",lat:49.75,lng:6.16666666,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Latvia",lat:57,lng:25,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Morocco",lat:32,lng:-5,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"Monaco",lat:43.73333333,lng:7.4,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Moldova",lat:47,lng:29,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Madagascar",lat:-20,lng:47,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Maldives",lat:3.25,lng:73,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Mexico",lat:23,lng:-102,continentKey:"North America",handoffKey:"North America",sizeTier:"large"},{name:"Marshall Islands",lat:9,lng:168,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"North Macedonia",lat:41.83333333,lng:22,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Mali",lat:17,lng:-4,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Malta",lat:35.83333333,lng:14.58333333,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Myanmar",lat:22,lng:98,continentKey:"Asia",handoffKey:"Asia",sizeTier:"medium"},{name:"Montenegro",lat:42.5,lng:19.3,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Mongolia",lat:46,lng:105,continentKey:"Asia",handoffKey:"Asia",sizeTier:"large"},{name:"Mozambique",lat:-18.25,lng:35,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Mauritania",lat:20,lng:-12,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Mauritius",lat:-20.28333333,lng:57.55,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Malawi",lat:-13.5,lng:34,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Malaysia",lat:2.5,lng:112.5,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Namibia",lat:-22,lng:17,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Niger",lat:16,lng:8,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Nigeria",lat:10,lng:8,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Nicaragua",lat:13,lng:-85,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Netherlands",lat:52.5,lng:5.75,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Norway",lat:62,lng:10,continentKey:"Europe",handoffKey:"Europe",sizeTier:"small"},{name:"Nepal",lat:28,lng:84,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Nauru",lat:-.53333333,lng:166.91666666,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"New Zealand",lat:-41,lng:174,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"small"},{name:"Oman",lat:21,lng:57,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Pakistan",lat:30,lng:70,continentKey:"Asia",handoffKey:"Asia",sizeTier:"medium"},{name:"Panama",lat:9,lng:-80,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Peru",lat:-10,lng:-76,continentKey:"South America",handoffKey:"South America",sizeTier:"medium"},{name:"Philippines",lat:13,lng:122,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Palau",lat:7.5,lng:134.5,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"Papua New Guinea",lat:-6,lng:147,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"small"},{name:"Poland",lat:52,lng:20,continentKey:"Europe",handoffKey:"Europe",sizeTier:"small"},{name:"North Korea",lat:40,lng:127,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Portugal",lat:39.5,lng:-8,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Paraguay",lat:-23,lng:-58,continentKey:"South America",handoffKey:"South America",sizeTier:"small"},{name:"Qatar",lat:25.5,lng:51.25,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Romania",lat:46,lng:25,continentKey:"Europe",handoffKey:"Europe",sizeTier:"small"},{name:"Russia",lat:60,lng:100,continentKey:"Europe",handoffKey:"Asia",sizeTier:"huge"},{name:"Rwanda",lat:-2,lng:30,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Saudi Arabia",lat:25,lng:45,continentKey:"Asia",handoffKey:"Asia",sizeTier:"large"},{name:"Sudan",lat:15,lng:30,continentKey:"Africa",handoffKey:"Africa",sizeTier:"large"},{name:"Senegal",lat:14,lng:-14,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"Singapore",lat:1.36666666,lng:103.8,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Solomon Islands",lat:-8,lng:159,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"Sierra Leone",lat:8.5,lng:-11.5,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"El Salvador",lat:13.83333333,lng:-88.91666666,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"San Marino",lat:43.76666666,lng:12.41666666,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Somalia",lat:10,lng:49,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Serbia",lat:44,lng:21,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"South Sudan",lat:7,lng:30,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"São Tomé and Príncipe",lat:1,lng:7,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Suriname",lat:4,lng:-56,continentKey:"South America",handoffKey:"South America",sizeTier:"small"},{name:"Slovakia",lat:48.66666666,lng:19.5,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Slovenia",lat:46.11666666,lng:14.81666666,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Sweden",lat:62,lng:15,continentKey:"Europe",handoffKey:"Europe",sizeTier:"small"},{name:"Eswatini",lat:-26.5,lng:31.5,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Seychelles",lat:-4.58333333,lng:55.66666666,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Syria",lat:35,lng:38,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Chad",lat:15,lng:19,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Togo",lat:8,lng:1.16666666,continentKey:"Africa",handoffKey:"Africa",sizeTier:"tiny"},{name:"Thailand",lat:15,lng:100,continentKey:"Asia",handoffKey:"Asia",sizeTier:"medium"},{name:"Tajikistan",lat:39,lng:71,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Turkmenistan",lat:40,lng:60,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Timor-Leste",lat:-8.83333333,lng:125.91666666,continentKey:"Asia",handoffKey:"Asia",sizeTier:"tiny"},{name:"Tonga",lat:-20,lng:-175,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"Trinidad and Tobago",lat:11,lng:-61,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Tunisia",lat:34,lng:9,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"Türkiye",lat:39,lng:35,continentKey:"Asia",handoffKey:"Asia",sizeTier:"medium"},{name:"Tuvalu",lat:-8,lng:178,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"Tanzania",lat:-6,lng:35,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Uganda",lat:1,lng:32,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"},{name:"Ukraine",lat:49,lng:32,continentKey:"Europe",handoffKey:"Europe",sizeTier:"medium"},{name:"Uruguay",lat:-33,lng:-56,continentKey:"South America",handoffKey:"South America",sizeTier:"small"},{name:"United States",lat:38,lng:-97,continentKey:"North America",handoffKey:"North America",sizeTier:"huge"},{name:"Uzbekistan",lat:41,lng:64,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Vatican City",lat:41.9,lng:12.45,continentKey:"Europe",handoffKey:"Europe",sizeTier:"tiny"},{name:"Saint Vincent and the Grenadines",lat:13.25,lng:-61.2,continentKey:"South America",handoffKey:"South America",sizeTier:"tiny"},{name:"Venezuela",lat:8,lng:-66,continentKey:"South America",handoffKey:"South America",sizeTier:"medium"},{name:"Vietnam",lat:16.16666666,lng:107.83333333,continentKey:"Asia",handoffKey:"Asia",sizeTier:"small"},{name:"Vanuatu",lat:-16,lng:167,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"Samoa",lat:-13.58333333,lng:-172.33333333,continentKey:"Oceania",handoffKey:"Oceania",sizeTier:"tiny"},{name:"Yemen",lat:15,lng:48,continentKey:"Asia",handoffKey:"Asia",sizeTier:"medium"},{name:"South Africa",lat:-29,lng:24,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Zambia",lat:-15,lng:30,continentKey:"Africa",handoffKey:"Africa",sizeTier:"medium"},{name:"Zimbabwe",lat:-20,lng:30,continentKey:"Africa",handoffKey:"Africa",sizeTier:"small"}];
    }
})();
